import Navigation from '../model/Navigation';
/*
  * Sequence of events that occur from navigation start to end.
 */

export var EventTypes = {
  EMPTY: 'EMPTY',
  NAVIGATION_START: 'NAVIGATION_START',
  NAVIGATION_RESULT_MATCHED: 'NAVIGATION_RESULT_MATCHED',
  CHILDREN_CONFIG_REQUESTED: 'CHILDREN_CONFIG_REQUESTED',
  CHILDREN_CONFIG_LOADED: 'CHILDREN_CONFIG_LOADED',
  CHILDREN_LOADING: 'CHILDREN_LOADING',
  CHILDREN_LOADED: 'CHILDREN_LOADED',
  NAVIGATION_RETRY: 'NAVIGATION_RETRY',
  NAVIGATION_ACTIVATING: 'NAVIGATION_ACTIVATING',
  NAVIGATION_ACTIVATED: 'NAVIGATION_ACTIVATED',
  NAVIGATION_TRANSITION_START: 'NAVIGATION_TRANSITION_START',
  NAVIGATION_TRANSITION_END: 'NAVIGATION_TRANSITION_END',
  NAVIGATION_CANCELLED: 'NAVIGATION_CANCELLED',
  NAVIGATION_ERROR: 'NAVIGATION_ERROR',
  NAVIGATION_END: 'NAVIGATION_END'
};